<template>
  <div style="position:relative">

    <v-container class="pa-0 grey" :class="darkMode?'darken-3':'lighten-4'" fluid>
      <popup-hint hint="apps">
        <template v-slot:breadcrumbs>
          <v-row no-gutters>
            <v-col class="title pl-7 pt-3">Apps</v-col>
          </v-row>
        </template>
        <template v-slot:top>
          Apps provide integrations with other applications or additional features.
          <em>Some apps will incur extra monthly charges when installed.</em>
        </template>
      </popup-hint>
<!--
      <v-row no-gutters>
        <v-col class="title pl-7 pt-3">Apps</v-col>
      </v-row>
-->
    </v-container>

    <v-card color="grey" :class="darkMode?'darken-3':'lighten-4'" flat height="calc(100vh - 92px)" class="overflow-y pt-4">
      <v-container class="pt-0" fluid>
        <v-row>
          <template v-for="app in installedApps">
            <app-pick :app="app" :key="app.name" @remove="updateAddOns(app, false)" @help="$emit('help',$event)"/>
          </template>
        </v-row>

        <v-divider class="my-4"/>
        <v-row>
          <template v-for="app in uninstalledApps">
            <app-pick :app="app" :key="app.name" @add="updateAddOns(app, true)" @help="$emit('help',$event)"/>
          </template>
        </v-row>

      </v-container>
    </v-card>

  </div>

</template>

<script>
import AppPick from '@/views/apps/AppPick';

export default {
  name: 'Apps',
  components: {AppPick},
  data() {
    return {
      apps: [
             {name:"Shopify",title:"Shopify",icon:'shopify_logo_black.png',iconSize:200,price:25,installed:false,enabled:true,alert:false,
              help:{topicId:'RgAHAAAA',articleId:'RwCRAQAA'},
              description:'Process Shopify orders in PURTRAK and keep consistent inventory.'},
             {name:"Square",title:"Square",icon:'Square_combinationmark_black.png',iconSize:200,price:25,installed:false,enabled:true,alert:false,
              help:{topicId:'RgAHAAAA',articleId:'RwCSAQAA'},
              description:'Process Square orders in PURTRAK and keep consistent inventory.'},
             {name:"Portal",title:"Customer Portal",icon:'logo.png',iconSize:60,price:100,installed:false,enabled:true,alert:false,
              help:{topicId:'RgAHAAAA',articleId:'RwCTAQAA'},
              description:'Give your contract customers visibility into inventory and production.'},
/*
             {name:"Wix",title:"Wix",icon:'shopify_logo_black.png',iconSize:200,price:50,installed:false,
              description:'Process Wix orders in PURTRAK and keep consistent inventory.'},
              */
            ]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    installedApps() {
      return this.apps.filter(app => app.installed);
    },
    uninstalledApps() {
      return this.apps.filter(app => !app.installed);
    }
  },
  async created() {
    for (const app of this.apps)
      app.installed = this.company.addOns.includes(app.name);
    if (this.company.allowAccounting)
      this.apps.splice(0, 0,
                      {name:"QuickBooks",title:"QuickBooks Online",icon:'QB_64x64.png',iconSize:64,price:0,installed:true,alert:false,
                      help:{topicId:"RgAFAAAA",articleId:'RwAzAAAA'},
                      description:'Automatically create QBO bills and invoices and have all inventory and production activity update your GL.'});

    const results = await this.$apiCall(`query Apps {
                                            addOnsWithAlerts
                                          }`,
                                        {});
    if (!results.error)
      results.data.addOnsWithAlerts.forEach(app => this.apps.find(a => a.name === app).alert = true);
  },
  methods: {
    async updateAddOns(app, installed) {
      app.installed = installed;
      const results = await this.$apiCall(`mutation Apps($addOns:[String]!) {
                                            companySetPlan(addOns:$addOns) {
                                              addOns
                                            }
                                          }`,
                                          {addOns:this.installedApps.map(app => app.name).filter(app => app.name !== 'QuickBooks')});
      if (!results.error)
        Object.assign(this.company, results.data.companySetPlan);
    }
  }
}
</script>